import * as React from 'react'
import styled from 'style/styled-components'

const StyledCircle = styled.div`
  border-radius: 50%;
  height: ${(props: CircleProps): number => props.radius}px;
  width: ${(props: CircleProps): number => props.radius}px;
`

const Circle = (props: CircleProps): JSX.Element => (
  <StyledCircle {...props}/>
)

interface CircleProps extends React.HTMLAttributes<HTMLDivElement> {
  radius: number
}

export default Circle



// WEBPACK FOOTER //
// ./src/components/_atoms/circle.tsx